import { Booking, LocationDetails } from "@/types/*";
import { DEFAULT_NVTR_COUNTRY_CODE } from "constants/variables";

type CheckForInternationalFlightsArgs = {
  origin: LocationDetails;
  destination: LocationDetails;
};

export const checkForInternationalFlights = ({ origin, destination }: CheckForInternationalFlightsArgs) => {
  try {
    return (origin && origin.locationDetails.countryCode !== DEFAULT_NVTR_COUNTRY_CODE) || (destination && destination.locationDetails.countryCode !== DEFAULT_NVTR_COUNTRY_CODE) || false;
  } catch (error) {
    console.warn("Error in checking if the flight is international", error);
  }
  return false;
};

export const checkForInternationalBooking = (bookingInState: Booking) => {
  try {
    return bookingInState.journeys.some((j) => j.segments.some((s)=> s.international));
  } catch (error) {
    console.warn("Error in checking if the flight is international", error);
  }
  return false;
};

